   <ngx-spinner type="ball-scale-multiple" [fullScreen]="false"></ngx-spinner>